import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7de23cef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container grid grid-cols-4 gap-6 mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "boost-container"
}
const _hoisted_3 = { class: "main-label" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_5 = { class: "acs-boost-left" }
const _hoisted_6 = { class: "acs-boost-right" }
const _hoisted_7 = {
  key: 1,
  class: "boost-container"
}
const _hoisted_8 = { class: "main-label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_10 = { class: "flex mt-2" }
const _hoisted_11 = { class: "boost-left" }
const _hoisted_12 = { class: "boost-right" }
const _hoisted_13 = {
  key: 0,
  class: "boost-x-emerald"
}
const _hoisted_14 = {
  key: 1,
  href: "https://docs.acryptos.com/acryptos-farms#acs-rewards-boost",
  target: "_blank",
  class: "underline text-sssm lg:text-xs"
}
const _hoisted_15 = {
  key: 0,
  class: "mt-1.5 flex"
}
const _hoisted_16 = { class: "boost-left" }
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = {
  key: 1,
  class: "mt-1.5 flex"
}
const _hoisted_19 = { class: "boost-left" }
const _hoisted_20 = { class: "boost-right" }
const _hoisted_21 = {
  key: 2,
  class: "flex mt-1.5"
}
const _hoisted_22 = { class: "boost-left" }
const _hoisted_23 = { class: "boost-right" }
const _hoisted_24 = { class: "flex mt-1.5" }
const _hoisted_25 = { class: "boost-left" }
const _hoisted_26 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.farmVault.vault?.hasNft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.farmVault.vault.tokenSymbol) + " " + _toDisplayString(_ctx.$t('boost')), 1),
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataShow, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex mt-2",
              key: index
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(item.label, [_ctx.farmVault.vault.tokenSymbol])) + ": ", 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.farmVault.vault.stats.value[item.value]?.gtn(0)
              ? `${_ctx.showTokenBalance(_ctx.farmVault.vault.stats.value[item.value])} ${
                  _ctx.farmVault.vault.tokenSymbol
                }`
              : '--'), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.farmVault.farm?.totalWeight && !_ctx.farmVault.farm.deprecated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.farmVault.farm.masterFarm?.rewardTokenSymbol === 'WAV'
            ? 'TGW'
            : _ctx.farmVault.farm.masterFarm?.rewardTokenSymbol) + " " + _toDisplayString(_ctx.$t('boost')) + " ", 1),
            _createVNode(_component_BalIcon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBoostDetail = !_ctx.showBoostDetail)),
              class: "cursor-pointer ml-auto text-amber-550",
              name: 
            _ctx.showBoostDetail
              ? 'ant-design:minus-circle-outlined'
              : 'ant-design:plus-circle-outlined'
          ,
              size: "sm"
            }, null, 8, ["name"])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('current_boost')) + ":", 1),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.farmVault.farm.stats.value.currentBoostX)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.fwp(_ctx.farmVault.farm.stats.value.currentBoostX) + 'X'), 1))
                : (_openBlock(), _createElementBlock("a", _hoisted_14, _toDisplayString(_ctx.$t('2.5x_your_apr')), 1))
            ])
          ]),
          (_ctx.showBoostDetail)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (
            _ctx.farmVault.farm.stats.value.currentBoostX &&
            _ctx.farmVault.farm.stats.value.futureBoostX
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('future_boost')) + ":", 1),
                      _createElementVNode("div", {
                        class: _normalizeClass([
              _ctx.fwp(_ctx.farmVault.farm.stats.value.futureBoostX) >
              _ctx.fwp(_ctx.farmVault.farm.stats.value.currentBoostX)
                ? 'boost-emerald'
                : 'boost-zink'
            , "boost-right"])
                      }, [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forceBoost && _ctx.forceBoost(...args)))
                        }, _toDisplayString(_ctx.$t('force')), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(`${_ctx.fwp(_ctx.farmVault.farm.stats.value.futureBoostX)}X`), 1)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.farmVault.farm.stats.value.maxBoostAcsNeeded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('for')) + " 2.5X:", 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(`${_ctx.fwp(_ctx.farmVault.farm.stats.value.maxBoostAcsNeeded)} ${
                _ctx.farmVault.farm.masterFarm?.rewardTokenSymbol === 'WAV'
                  ? 'WAV-ACS-BNB'
                  : _ctx.farmVault.farm.masterFarm?.rewardTokenSymbol
              }`), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.farmVault.farm.stats.value.maxBoostOnFirst)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('2.5x_on_first')) + ":", 1),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(`${_ctx.showTokenBalance(
                _ctx.farmVault.farm.stats.value.maxBoostOnFirstInVaultToken
                  ? _ctx.farmVault.farm.stats.value.maxBoostOnFirstInVaultToken
                  : _ctx.farmVault.farm.stats.value.maxBoostOnFirst
              )} ${
                _ctx.farmVault.farm.stats.value.maxBoostOnFirstInVaultToken
                  ? _ctx.farmVault.vault.tokenSymbol
                  : _ctx.farmVault.farm.tokenSymbol
              } ${
                _ctx.farmVault.farm.stats.value.maxBoostOnFirstUsd
                  ? `($${_ctx.fwp(_ctx.farmVault.farm.stats.value.maxBoostOnFirstUsd)})`
                  : ''
              }`), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("a", {
                      class: "vault-detail-boost-docs",
                      href: `${
                _ctx.farmVault.farm.masterFarm?.rewardTokenSymbol === 'WAV'
                  ? 'https://docs.thegreatwave.io/tokenomics#farm-boost'
                  : 'https://docs.acryptos.com/acryptos-farms#user-interface'
              }`,
                      target: "_blank"
                    }, _toDisplayString(_ctx.$t('docs')), 9, _hoisted_26)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}